import { render, staticRenderFns } from "./ConventionTeaserInfo.vue?vue&type=template&id=0c2ab05e&scoped=true"
import script from "./ConventionTeaserInfo.vue?vue&type=script&lang=js"
export * from "./ConventionTeaserInfo.vue?vue&type=script&lang=js"
import style0 from "./ConventionTeaserInfo.vue?vue&type=style&index=0&id=0c2ab05e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2ab05e",
  null
  
)

export default component.exports